import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";
import UserDetails from "../../admin/users/UserDetails";
import MaterialModal from "../MaterialModal";

const UserDetailsModal = ({ isOpen, modalProps }) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("USER_DETAILS"));

    return (
        <MaterialModal
            id="user-details-modal"
            isOpen={isOpen}
            onClose={hide}
            title={modalProps.title || "User Details"}
            footer={modalProps.footer}
            showPrimaryButton={false}
            cancelButtonText="Close"
        >
            <UserDetails userId={modalProps.userId} />
        </MaterialModal>
    );
};

UserDetailsModal.propTypes = {
    isOpen: PropTypes.bool,
    modalProps: PropTypes.object,
};

export default withModal(UserDetailsModal, "USER_DETAILS");
